<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title>{{'従業員更新'}}</v-card-title>
        <form>
          <v-flex sm12>
            <v-text-field v-model="userId" label="従業員ID" disabled></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="lastName" v-validate="'required|max:60'" :counter="60" data-vv-name="lastName" required >
              <template v-slot:label>
                <span style="color: red;">*</span> 名前(JP)
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="firstName" label="名前(EN)" v-validate="'required|max:60'" :counter="60" data-vv-name="firstName"></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingSex.sexCode"
              :items="sexItems"
              item-text="sexName"
              item-value="sexCode"              
              return-object
              required
            >
              <template v-slot:label>
                <span style="color: red;">*</span> 性別
              </template>
            </v-select>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="country" v-validate="'required|max:60'" :counter="60" data-vv-name="country" required >
              <template v-slot:label>
                <span style="color: red;">*</span> 勤務地(Country)
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="city" v-validate="'required|max:60'" :counter="60" data-vv-name="city" required >
              <template v-slot:label>
                <span style="color: red;">*</span> 勤務地(City)
              </template>
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingDepth.depthCode"
              :items="depthItems"
              item-text="depthName"
              item-value="depthCode"
              label="部署"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingTeam.teamCode"
              :items="teamItems"
              item-text="teamName"
              item-value="teamCode"
              label="課"
              return-object
            ></v-select>
          </v-flex>
          <v-flex sm12>
            
            <v-select
              v-model="editingTeamDetail.teamDetailCode"
              :items="teamDetailItems"
              item-text="teamDetailName"
              item-value="teamDetailCode"
              label="Group"
              return-object
              required
            >
              <template v-slot:label>
                <span style="color: red;">*</span> グループ
              </template>
          </v-select>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingStaffType.staffTypeCode"
              :items="staffTypeItems"
              item-text="staffTypeName"
              item-value="staffTypeCode"
              return-object
              required
            >
              <template v-slot:label>
                <span style="color: red;">*</span> 契約種類
              </template>
            </v-select>
          </v-flex>
          <v-flex sm12>
            <v-select
              v-model="editingAdminRole.adminRoleCode"
              :items="adminRoleItems"
              item-text="adminRoleName"
              item-value="adminRoleCode"
              return-object
              required
            >
              <template v-slot:label>
                <span style="color: red;">*</span> システム権限
              </template>
            </v-select>
          </v-flex>
          <v-flex sm12>
            <v-text-field v-model="mailAddress" label="e-mail" v-validate="'required|max:60'" :counter="60" data-vv-name="mailAddress" ></v-text-field>
          </v-flex>

          <div style="height: 55px;"></div>
          <v-layout row wrap justify-space-between>
            <v-flex xs12 sm4 class="pa-2">
              <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-user-upload' }" height="48">
                <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
              </v-btn>
            </v-flex>
            <v-flex xs12 sm4 class="pa-2">
              <v-btn block color="primary" dark @click="updateUser()" height="48">
                <v-icon class="ma-2" :loading="loading2" :disabled="loading2" dark small>save</v-icon>
                {{ $t('update-btn') }}
              </v-btn>
            </v-flex>
            <v-flex xs12 sm4 class="pa-2">
              <v-btn block color="error" dark @click="deleteUser()" height="48">
                <v-icon class="ma-2" :loading="loading2" :disabled="loading2" dark small>delete</v-icon>
                {{ $t('delete-btn') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-container>
    </v-card>    
  </v-container>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import ServerApiCallService from '@/services/ServerApiCallService.js'

Vue.use(VeeValidate)

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.userId = this.$route.params.userId

    this.loadUsers()
  },
  methods: {
    loadUsers() {
      let thisObj = this
      // 初期表示時のP
      thisObj.loading = true

      let request = { userId: this.userId }
      ServerApiCallService.user(request)
        .then(response => {
          thisObj.user = response.data.user
          
          this.lastName = thisObj.user.lastName
          this.firstName = thisObj.user.firstName
          this.country = thisObj.user.country
          this.city = thisObj.user.city
          this.mailAddress = thisObj.user.mailAddress
                    
          // 성별
          for (let i=0; i<this.sexItems.length; i++) {
            if (this.sexItems[i].sexName == thisObj.user.sex) {
              this.editingSex.sexCode = this.sexItems[i].sexCode
              this.editingSex.sexName = this.sexItems[i].sexName
            }
          }
          // 부서
          for (let i=0; i<this.depthItems.length; i++) {
            if (this.depthItems[i].depthName == thisObj.user.userGroup) {
              this.editingDepth.depthCode = this.depthItems[i].depthCode
              this.editingDepth.depthName = this.depthItems[i].depthName
            }
          }
          // 과
          for (let i=0; i<this.teamItems.length; i++) {
            if (this.teamItems[i].teamName == thisObj.user.userGroup2) {
              this.editingTeam.teamCode = this.teamItems[i].teamCode
              this.editingTeam.teamName = this.teamItems[i].teamName
            }
          }
          // Group
          for (let i=0; i<this.teamDetailItems.length; i++) {
            if (this.teamDetailItems[i].teamDetailName == thisObj.user.userGroup3) {
              this.editingTeamDetail.teamDetailCode = this.teamDetailItems[i].teamDetailCode
              this.editingTeamDetail.teamDetailName = this.teamDetailItems[i].teamDetailName
            }
          }
          // 계약종류
          for (let i=0; i<this.staffTypeItems.length; i++) {
            if (this.staffTypeItems[i].staffTypeName == thisObj.user.staffType) {
              this.editingStaffType.staffTypeCode = this.staffTypeItems[i].staffTypeCode
              this.editingStaffType.staffTypeName = this.staffTypeItems[i].staffTypeName
            }
          }
          // 권한
          this.editingAdminRole.adminRoleCode = thisObj.user.adminRole
          this.editingAdminRole.adminRoleName = this.adminRoleItems[thisObj.user.adminRole].adminRoleName
                    
          // 初期表示時の
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    deleteUser() {

      let result = window.confirm("削除しますか");
      if (!result) {
        return false;
      }

      let request = { userId: this.userId }
      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-user-upload',
      }

      ServerApiCallService.userDelete(request, sendContext)
        .then(() => {
          console.log('completed new item')
          thisObj.loading2 = false
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })
    },
    updateUser() {
      let thisObj = this
      thisObj.loading2 = true

      // 성별
      if (this.editingSex.sexCode.sexCode) {
        this.editingSex.sexName = this.editingSex.sexCode.sexName
      }
      // 부서
      if (this.editingDepth.depthCode.depthCode) {
        this.editingDepth.depthName = this.editingDepth.depthCode.depthName
      }      
      // 과
      if (this.editingTeam.teamCode.teamCode) {
        this.editingTeam.teamName = this.editingTeam.teamCode.teamName
      }
      // 그룹
      if (this.editingTeamDetail.teamDetailCode.teamDetailCode) {
        this.editingTeamDetail.teamDetailName = this.editingTeamDetail.teamDetailCode.teamDetailName
      }
      // 계약종류
      if (this.editingStaffType.staffTypeCode.staffTypeCode) {
        this.editingStaffType.staffTypeName = this.editingStaffType.staffTypeCode.staffTypeName
      }
      // 권한
      if (this.editingAdminRole.adminRoleCode.adminRoleCode) {
        this.editingAdminRole.adminRoleName = this.editingAdminRole.adminRoleCode.adminRoleName
      }

      if (this.lastName == "") {
        alert("名前(JP)を入力してください")
        return
      }
      if (this.editingSex.sexCode == "") {
        alert("性別を選択してください")
        return
      }
      if (this.editingSex.sexName == "") {
        alert("性別を選択してください")
        return
      }
      if (this.country == "") {
        alert("勤務地(Country)を入力してください")
        return
      }
      if (this.city == "") {
        alert("勤務地(City)を入力してください")
        return
      }
      
      if (this.editingTeamDetail.teamDetailCode == "") {
        alert("グループを選択してください")
        return
      }
      if (this.editingTeamDetail.teamDetailName == "") {
        alert("グループを選択してください")
        return
      }
      if (this.editingStaffType.staffTypeCode == "") {
        alert("契約種類を選択してください")
        return
      }
      if (this.editingStaffType.staffTypeName == "") {
        alert("契約種類を選択してください")
        return
      }
      if (this.editingAdminRole.adminRoleCode == "") {
        alert("システム権限を選択してください")
        return
      }
      if (this.editingAdminRole.adminRoleName == "") {
        alert("システム権限を選択してください")
        return
      }

      let request = {
        userId: this.userId,
        lastName: this.lastName,
        firstName: this.firstName,
        sex: this.editingSex.sexName,
        country: this.country,
        city: this.city,
        userGroup: this.editingDepth.depthName,
        userGroup2: this.editingTeam.teamName,
        userGroup3: this.editingTeamDetail.teamDetailName,
        staffType: this.editingStaffType.staffTypeName,
        adminRole: this.editingAdminRole.adminRoleName,
        mailAddress: this.mailAddress
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-user-upload',
      }

      ServerApiCallService.userUpdate(request, sendContext)
        .then(() => {
          console.log('completed new item')
          thisObj.loading2 = false
        })
        .catch((error) => {
          console.log('There was an error:', error.response)
        })
    }
  },
  data() {
    return {
      loading: true,
      loading2: false,

      user: {},
      userId: '',
      lastName: '',
      firstName: '',
      country: '',
      city: '',
      mailAddress: '',
      editingSex: {
        sexName: '',
        sexCode: ''
      },
      editingTeam: {
        teamName: '',
        teamCode: ''
      },
      editingTeamDetail: {
        teamDetailName: '',
        teamDetailCode: ''
      },
      editingDepth: {
        depthName: '',
        depthCode: ''
      },
      editingStaffType: {
        staffTypeName: '',
        staffTypeCode: ''
      },
      editingAdminRole: {
        adminRoleName: '',
        adminRoleCode: ''
      },
      sexItems: [
        {
          sexName: '男',
          sexCode: '0'
        },
        {
          sexName: '女',
          sexCode: '1'
        }
      ],      
      teamItems: [
        {
          teamName: '',
          teamCode: '0'
        },
        {
          teamName: '営業サポート',
          teamCode: '1'
        },
        {
          teamName: '新規事業開発課',
          teamCode: '2'
        },
        {
          teamName: '営業課',
          teamCode: '3'
        },
        {
          teamName: '店舗課',
          teamCode: '4'
        },
        {
          teamName: 'システム管理',
          teamCode: '5'
        },
        {
          teamName: 'デザイン管理',
          teamCode: '6'
        }
      ],      
      teamDetailItems: [
        {
          teamDetailName: '全体',
          teamDetailCode: '99'
        },
        // {
        //   teamDetailName: '東京',
        //   teamDetailCode: '1'
        // },
        // {
        //   teamDetailName: '大阪',
        //   teamDetailCode: '2'
        // },
        // {
        //   teamDetailName: '京都',
        //   teamDetailCode: '3'
        // },
        // {
        //   teamDetailName: '沖縄',
        //   teamDetailCode: '4'
        // },
        // {
        //   teamDetailName: '札幌',
        //   teamDetailCode: '5'
        // },
        {
          teamDetailName: 'その他',
          teamDetailCode: '0'
        },
        {
          teamDetailName: '青森県',
          teamDetailCode: '2'
        },
        {
          teamDetailName: '岩手県',
          teamDetailCode: '3'
        },
        {
          teamDetailName: '宮城県',
          teamDetailCode: '4'
        },
        {
          teamDetailName: '秋田県',
          teamDetailCode: '5'
        },
        {
          teamDetailName: '山形県',
          teamDetailCode: '6'
        },
        {
          teamDetailName: '福島県',
          teamDetailCode: '7'
        },
        {
          teamDetailName: '茨城県',
          teamDetailCode: '8'
        },
        {
          teamDetailName: '栃木県',
          teamDetailCode: '9'
        },
        {
          teamDetailName: '群馬県',
          teamDetailCode: '10'
        },
        {
          teamDetailName: '埼玉県',
          teamDetailCode: '11'
        },
        {
          teamDetailName: '千葉県',
          teamDetailCode: '12'
        },
        {
          teamDetailName: '東京都',
          teamDetailCode: '13'
        },
        {
          teamDetailName: '神奈川県',
          teamDetailCode: '14'
        },
        {
          teamDetailName: '山梨県',
          teamDetailCode: '15'
        },
        {
          teamDetailName: '長野県',
          teamDetailCode: '16'
        },
        {
          teamDetailName: '新潟県',
          teamDetailCode: '17'
        },
        {
          teamDetailName: '富山県',
          teamDetailCode: '18'
        },
        {
          teamDetailName: '石川県',
          teamDetailCode: '19'
        },
        {
          teamDetailName: '福井県',
          teamDetailCode: '20'
        },
        {
          teamDetailName: '岐阜県',
          teamDetailCode: '21'
        },
        {
          teamDetailName: '静岡県',
          teamDetailCode: '22'
        },
        {
          teamDetailName: '愛知県',
          teamDetailCode: '23'
        },
        {
          teamDetailName: '三重県',
          teamDetailCode: '24'
        },
        {
          teamDetailName: '滋賀県',
          teamDetailCode: '25'
        },
        {
          teamDetailName: '京都府',
          teamDetailCode: '26'
        },
        {
          teamDetailName: '大阪府',
          teamDetailCode: '27'
        },
        {
          teamDetailName: '兵庫県',
          teamDetailCode: '28'
        },
        {
          teamDetailName: '奈良県',
          teamDetailCode: '29'
        },
        {
          teamDetailName: '和歌山県',
          teamDetailCode: '30'
        },
        {
          teamDetailName: '鳥取県',
          teamDetailCode: '31'
        },
        {
          teamDetailName: '島根県',
          teamDetailCode: '32'
        },
        {
          teamDetailName: '岡山県',
          teamDetailCode: '33'
        },
        {
          teamDetailName: '広島県',
          teamDetailCode: '34'
        },
        {
          teamDetailName: '山口県',
          teamDetailCode: '35'
        },
        {
          teamDetailName: '徳島県',
          teamDetailCode: '36'
        },
        {
          teamDetailName: '香川県',
          teamDetailCode: '37'
        },
        {
          teamDetailName: '愛媛県',
          teamDetailCode: '38'
        },
        {
          teamDetailName: '高知県',
          teamDetailCode: '39'
        },
        {
          teamDetailName: '福岡県',
          teamDetailCode: '40'
        },
        {
          teamDetailName: '佐賀県',
          teamDetailCode: '41'
        },
        {
          teamDetailName: '長崎県',
          teamDetailCode: '42'
        },
        {
          teamDetailName: '熊本県',
          teamDetailCode: '43'
        },
        {
          teamDetailName: '大分県',
          teamDetailCode: '44'
        },
        {
          teamDetailName: '宮崎県',
          teamDetailCode: '45'
        },
        {
          teamDetailName: '鹿児島県',
          teamDetailCode: '46'
        },
        {
          teamDetailName: '沖縄県',
          teamDetailCode: '47'
        },
        {
          teamDetailName: '北海道',
          teamDetailCode: '1'
        },
      ],      
      depthItems: [
      {
          depthName: '',
          depthCode: '0'
        },
        {
          depthName: '免税ビジネス部',
          depthCode: '1'
        },
        {
          depthName: '店舗営業サポート部',
          depthCode: '2'
        },
        {
          depthName: '国内営業部',
          depthCode: '3'
        },
        {
          depthName: '国際営業部',
          depthCode: '4'
        },
        {
          depthName: '業務管理部',
          depthCode: '5'
        },
        {
          depthName: '人事総務部',
          depthCode: '6'
        },
        {
          depthName: '広告部',
          depthCode: '7'
        },
        {
          depthName: 'システムデザイン部',
          depthCode: '8'
        },
        {
          depthName: '商品企画開発部',
          depthCode: '9'
        },
        {
          depthName: '物流部',
          depthCode: '10'
        },
        {
          depthName: '業務推進部',
          depthCode: '11'
        }
      ],      
      staffTypeItems: [
        {
          staffTypeName: '役員',
          staffTypeCode: '0'
        },
        {
          staffTypeName: '正社員',
          staffTypeCode: '1'
        },
        {
          staffTypeName: '契約社員',
          staffTypeCode: '2'
        },
        {
          staffTypeName: 'アルバイト',
          staffTypeCode: '3'
        },
        {
          staffTypeName: 'その他',
          staffTypeCode: '4'
        }
      ],      
      adminRoleItems: [
        {
          adminRoleName: '一般社員',
          adminRoleCode: '0'
        },
        {
          adminRoleName: '人事管理者',
          adminRoleCode: '1'
        },
        {
          adminRoleName: '本部担当者',
          adminRoleCode: '2'
        },
        {
          adminRoleName: '発注確認者',
          adminRoleCode: '3'
        }
      ],
    }
  },
  $_veeValidate: {
    validator: 'new',
  }
}
</script>